export interface ArticleItem {
  id: number;
  title: string;
  cover: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readCount: string;
  tags: string[];
}

export const articles: ArticleItem[] = [
  {
    id: 1,
    title: "2025年最值得期待的10部新番动画推荐",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20collage%20of%20multiple%20new%20anime%20series%20characters%20with%20vibrant%20colors%2C%20exciting%20atmosphere%2C%202025%20upcoming%20shows%20theme%2C%20professional%20illustration%2C%20dynamic%20composition%2C%20filled%20with%20variety%20of%20characters&width=1200&height=600&seq=article-cover-01&orientation=landscape",
    excerpt: "新的一年又有大量精彩新番来袭！本文为大家精选了2025年最值得期待的10部动漫作品，从热血战斗到治愈日常应有尽有。",
    content: `<p>2025年对动漫迷来说注定是丰收的一年。各大动画制作公司纷纷推出重磅作品，让人目不暇接。下面就让我们一起来看看今年最值得期待的10部新番吧！</p>
<h3>1. 《鬼灭之刃 无限城篇》</h3>
<p>作为鬼灭之刃系列的完结篇，无限城篇将呈现炭治郎与鬼杀队对抗无惨的最终决战。ufotable一贯的精良制作水准让人充满期待，这无疑是2025年最受瞩目的作品。</p>
<h3>2. 《葬送的芙莉莲》第二季</h3>
<p>第一季以9.7的高分成为年度最佳动画，第二季将继续讲述芙莉莲的旅途。MADHOUSE的制作水准有目共睹，相信第二季会延续第一季的优秀品质。</p>
<h3>3. 《咒术回战》第三季</h3>
<p>死灭回游篇即将登场！作为咒术回战漫画中最精彩的篇章之一，MAPPA将如何呈现这场大规模的咒术师混战，令人无比期待。</p>
<h3>4. 《间谍过家家》第三季</h3>
<p>佛杰一家的温馨日常将继续上演。WIT STUDIO与CloverWorks联手打造的这部作品，凭借独特的家庭喜剧风格持续圈粉。</p>
<h3>5. 《迷宫饭》第二季</h3>
<p>在迷宫吃魔物的奇妙冒险还将继续。TRIGGER独特的动画风格让这部作品脱颖而出，第二季将展现更多精彩的迷宫美食。</p>
<p>以上只是2025年众多新番中的冰山一角。无论你喜欢什么类型的动漫，相信今年总有一部作品能打动你的心。让我们一起期待这些精彩的动画吧！</p>`,
    category: "新番推荐",
    author: "奶水动漫编辑部",
    date: "2025-01-15",
    readCount: "12.8万",
    tags: ["新番", "2025", "推荐", "年度盘点"]
  },
  {
    id: 2,
    title: "深度解析：为什么《葬送的芙莉莲》能成为年度神作？",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20elf%20mage%20girl%20in%20white%20dress%20traveling%20through%20beautiful%20countryside%2C%20nostalgic%20atmosphere%2C%20sunset%20golden%20hour%20lighting%2C%20emotional%20deep%20storytelling%20vibe%2C%20MADHOUSE%20animation%20quality%2C%20artistic%20composition&width=1200&height=600&seq=article-cover-02&orientation=landscape",
    excerpt: "豆瓣9.7分、MyAnimeList年度第一，《葬送的芙莉莲》凭什么征服全球动漫迷？从叙事手法到情感表达，深度剖析这部现象级作品。",
    content: `<p>《葬送的芙莉莲》自开播以来便引发了巨大反响，不仅在日本本土获得极高评价，在海外同样征服了无数观众。豆瓣评分9.7，MyAnimeList评分位居历史第一，这部作品到底有什么魔力？</p>
<h3>独特的叙事视角</h3>
<p>与大多数奇幻冒险作品不同，《葬送的芙莉莲》选择了一个极具新意的切入点——故事从「打败魔王之后」开始。这种后日谈式的叙事结构，让作品跳脱了传统冒险故事的框架，转而探讨更深层的主题。</p>
<p>精灵芙莉莲拥有近乎永恒的生命，她的时间感知与人类截然不同。当勇者辛美尔去世时，芙莉莲才第一次真正体会到「失去」的滋味。这种长生种与短生种之间的时间鸿沟，构成了作品最核心的情感张力。</p>
<h3>极致的制作水准</h3>
<p>MADHOUSE在这次改编中展现了极高的制作水准。无论是精美的背景美术、流畅的动作场面，还是细腻的人物表情，每一帧都堪称艺术品。特别是Evan Call创作的配乐，将作品的氛围感提升到了一个新的高度。</p>
<h3>深刻的情感内核</h3>
<p>作品最打动人心的地方在于它对「关系」的探讨。芙莉莲在旅途中不断回忆起与辛美尔一行人的过往，那些看似平凡的日常，在时间的流逝中变得无比珍贵。这种对记忆与情感的细腻刻画，让观众产生强烈的共鸣。</p>
<p>总的来说，《葬送的芙莉莲》之所以能成为年度神作，是因为它在优秀的制作基础上，讲述了一个关于时间、记忆与人性的深刻故事。</p>`,
    category: "深度分析",
    author: "奶水动漫编辑部",
    date: "2025-03-20",
    readCount: "9.6万",
    tags: ["深度分析", "葬送的芙莉莲", "MADHOUSE", "神作"]
  },
  {
    id: 3,
    title: "从零开始的动漫入门指南：新手必看的经典作品",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20collage%20of%20classic%20anime%20characters%20from%20different%20series%2C%20beginner%20friendly%20welcoming%20atmosphere%2C%20warm%20inviting%20colors%2C%20variety%20of%20genres%20represented%2C%20gateway%20to%20anime%20theme%2C%20colorful%20vibrant%20composition&width=1200&height=600&seq=article-cover-03&orientation=landscape",
    excerpt: "刚入坑动漫不知道从哪开始看？这篇入门指南为你精选了各类型的经典代表作，让你轻松找到适合自己的动漫世界。",
    content: `<p>动漫世界丰富多彩，但对于刚入坑的新手来说，面对海量的作品往往不知道从何看起。别担心，这篇指南将根据不同类型为你推荐最适合入门的经典作品。</p>
<h3>热血战斗类</h3>
<p>如果你喜欢激情澎湃的战斗场面，推荐从《鬼灭之刃》开始。精美的画面、紧凑的剧情、深刻的主题，让它成为近年最优秀的入坑作品。之后可以尝试《咒术回战》和经典的《进击的巨人》。</p>
<h3>治愈温情类</h3>
<p>如果你偏好温馨治愈的故事，《葬送的芙莉莲》是首选。这部作品以其独特的情感表达征服了全球观众。此外，《间谍过家家》的轻松幽默也适合放松心情。</p>
<h3>恋爱甜宠类</h3>
<p>恋爱番方面，推荐《辉夜大小姐想让我告白》。这部作品以天才间的恋爱头脑战为主线，既有搞笑的日常，也有甜蜜的心动时刻。《更衣人偶坠入爱河》则是另一部优秀的恋爱作品。</p>
<h3>奇幻冒险类</h3>
<p>喜欢奇幻世界的观众可以从《迷宫饭》开始，这部作品将美食与冒险完美结合。而《药屋少女的呢喃》则将宫廷推理与奇幻元素融为一体。</p>
<h3>搞笑日常类</h3>
<p>《孤独摇滚！》和《关于邻家的天使大人》都是优秀的搞笑/日常作品，轻松愉快又充满治愈感。</p>
<p>无论你选择从哪部开始，最重要的是享受动漫带来的快乐。欢迎来到这个精彩的世界！</p>`,
    category: "入门指南",
    author: "奶水动漫编辑部",
    date: "2025-02-10",
    readCount: "15.3万",
    tags: ["入门", "新手", "推荐", "指南"]
  },
  {
    id: 4,
    title: "日本动画制作流程全揭秘：一部动漫是如何诞生的",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20production%20studio%20interior%20with%20animators%20working%20at%20desks%2C%20storyboards%20on%20wall%2C%20drawing%20tablets%2C%20professional%20creative%20atmosphere%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20documentary%20style%2C%20detailed%20workspace&width=1200&height=600&seq=article-cover-04&orientation=landscape",
    excerpt: "从企划到播出，一部动画需要经历哪些环节？本文将带你走进日本动画制作的幕后，了解这部精密机器的运转方式。",
    content: `<p>每当我们沉浸在精彩动画中时，可能很少思考过这些画面背后凝聚了多少人的心血。一部完整的动画从无到有，需要经历多个复杂环节。</p>
<h3>1. 企划阶段</h3>
<p>一切从企划开始。制作委员会（由出版社、电视台、动画公司、广告代理商等组成）确定项目的基本方向，包括原作选择、预算规模、目标受众等。这个阶段决定了整部作品的基调。</p>
<h3>2. 脚本与系列构成</h3>
<p>系列构成负责整体剧情结构，将原作内容合理分配到每一集。随后由脚本家撰写每集的具体剧本，包括台词、场景描述、情绪标注等。</p>
<h3>3. 分镜与演出</h3>
<p>分镜是将文字脚本转化为视觉设计的关键步骤。分镜师需要决定每一卡的角度、构图、时间长度，这是动画的「蓝图」。演出则负责把控每集的整体节奏和氛围。</p>
<h3>4. 作画</h3>
<p>作画分为原画和动画两个阶段。原画师绘制关键帧，动画师则补充中间帧使动作流畅。这个环节是最耗费人力的部分，也是决定动画质量的核心。</p>
<h3>5. 后期制作</h3>
<p>完成作画后，进入上色、背景合成、摄影处理等环节。同时进行声优配音录制、音效制作和配乐创作。最终将所有元素合成为完整的动画。</p>
<h3>6. 播出</h3>
<p>经过漫长的制作周期，动画终于可以在电视台或流媒体平台与观众见面。但这并不意味着工作的结束——动画组可能同时已经在制作后续集数。</p>
<p>每一部动画背后都凝聚着数百名创作者的心血。了解了这些之后，再看动画时或许会有不一样的感受。</p>`,
    category: "行业科普",
    author: "奶水动漫编辑部",
    date: "2025-04-05",
    readCount: "8.2万",
    tags: ["行业", "制作", "科普", "幕后"]
  },
  {
    id: 5,
    title: "盘点那些被严重低估的冷门神作动画",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20hidden%20gem%20treasure%20chest%20with%20glowing%20anime%20characters%20emerging%2C%20mysterious%20atmosphere%2C%20forgotten%20masterpieces%20theme%2C%20warm%20golden%20glow%2C%20artistic%20illustration%2C%20nostalgic%20discovery%20mood&width=1200&height=600&seq=article-cover-05&orientation=landscape",
    excerpt: "在热门大作之外，还有大量优秀作品因种种原因未能获得应有的关注。本文整理了几部值得一看的冷门佳作。",
    content: `<p>在《鬼灭之刃》《咒术回战》等超级热门作品的阴影下，有许多同样优秀的动画没有得到应有的关注。今天我们就来盘点几部被严重低估的冷门佳作。</p>
<h3>《奇蛋物语》</h3>
<p>CloverWorks制作的原创动画，以精美的画面和深刻的主题探讨了青春期少女的心理创伤。虽然剧情后期略有争议，但其大胆的叙事尝试和出色的制作水准依然值得肯定。</p>
<h3>《薇薇 -萤石眼之歌-》</h3>
<p>WIT STUDIO的原创SF作品，讲述AI歌姬跨越百年的使命之旅。精良的动作场面配合动听的音乐，是一部被市场严重低估的佳作。</p>
<h3>《Sonny Boy》</h3>
<p>MADHOUSE的实验性作品，以其独特的视觉风格和哲学思考引发了小范围的讨论热潮。虽然叙事方式较为晦涩，但对于喜欢深度思考的观众来说是一部难得的作品。</p>
<h3>《平家物语》</h3>
<p>科学猴（Science SARU）改编的古典文学作品，以琵琶法师的视角讲述平家的兴衰。独特的画风和深沉的叙事赋予了这部古典故事全新的生命力。</p>
<p>这些冷门作品或许不像热门大作那样易于消化，但它们各自都有着独特的光芒。如果你看腻了主流作品，不妨给这些冷门佳作一个机会。</p>`,
    category: "动漫推荐",
    author: "奶水动漫编辑部",
    date: "2025-05-18",
    readCount: "6.7万",
    tags: ["冷门", "推荐", "神作", "盘点"]
  },
  {
    id: 6,
    title: "国产动漫崛起：近几年最值得关注的国漫作品",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20animation%20donghua%20style%20with%20traditional%20Chinese%20aesthetics%20and%20modern%203D%20rendering%2C%20epic%20fantasy%20characters%20in%20ancient%20Chinese%20setting%2C%20beautiful%20landscape%2C%20dramatic%20lighting%2C%20cinematic%20quality%2C%20cultural%20elements%20fusion&width=1200&height=600&seq=article-cover-06&orientation=landscape",
    excerpt: "国产动漫近年来发展迅猛，涌现出大量制作精良的优秀作品。从3D玄幻到2D古风，国漫正在向世界展示中国动画的实力。",
    content: `<p>曾几何时，「国漫」在动漫爱好者眼中还是一个略带贬义的词汇。但近年来，随着资本投入和技术进步，国产动漫已经发生了翻天覆地的变化。</p>
<h3>3D动画的崛起</h3>
<p>在3D动画领域，国漫已经达到了世界一流水平。《凡人修仙传》《斗破苍穹》《完美世界》等作品凭借精美的建模和流畅的动作设计吸引了大量观众。特别是《凡人修仙传》的写实风格，被誉为国产3D动画的标杆之作。</p>
<h3>2D古风的新高度</h3>
<p>2D动画方面，《雾山五行》以其惊艳的水墨画风和硬核的打斗场面一举封神。《时光代理人》则凭借独特的悬疑叙事和精美的画面在海外也获得了极高评价。</p>
<h3>大银幕的突破</h3>
<p>动画电影方面，《哪吒之魔童降世》以50亿票房打破了国产动画电影的纪录。《白蛇：缘起》《新神榜：杨戬》等作品也在不断探索中国传统文化的现代表达。</p>
<p>国产动漫正在以肉眼可见的速度进步。虽然与日本动画工业相比仍有差距，但按照目前的发展态势，国漫的未来值得期待。</p>`,
    category: "国漫专题",
    author: "奶水动漫编辑部",
    date: "2025-06-02",
    readCount: "11.4万",
    tags: ["国漫", "国产动画", "推荐", "崛起"]
  }
];

export function getArticleById(id: number): ArticleItem | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(id: number, limit: number = 3): ArticleItem[] {
  const current = getArticleById(id);
  if (!current) return [];
  return articles
    .filter((a) => a.id !== id)
    .slice(0, limit);
}